import { render, staticRenderFns } from "./PublicNavMenuGroup.vue?vue&type=template&id=ddeda6d6&"
import script from "./PublicNavMenuGroup.vue?vue&type=script&lang=js&"
export * from "./PublicNavMenuGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports